(() => {
  const canvas = document.querySelector('[data-orbit-mist]');
  if (!canvas) return;
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const header = canvas.closest('.om-header');
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const points = Array.from({length: 3200}, (_, index) => {
    const roll=Math.random(), layer=roll<.6?0:roll<.95?1:2;
    const pace=[.48,1,1.35][layer];
    const boost=index % 25 === 0 ? 4 + Math.random() * 2 : 1;
    const angle=Math.random()*Math.PI*2, speed=(.014+Math.random()*.025)*boost*pace;
    return {layer,x:Math.random()*2-1,y:Math.random()*2-1,z:Math.random()*2-1,
      vx:Math.cos(angle)*speed,vy:Math.sin(angle)*speed,vz:(Math.random()-.5)*.09*boost,
      phase:Math.random()*Math.PI*2,size:.32+Math.random()*.75,ink:.16+Math.random()*.28};
  });
  const wrap = n => ((n + 1) % 2 + 2) % 2 - 1;
  let width=1, height=1, raf=0, active=true, last=0, time=0, aim=0, lean=0;
  const place = () => {
    const h=header.getBoundingClientRect();
    width=Math.max(1,h.width); height=Math.max(1,h.height);
    canvas.style.left='0px';canvas.style.top='0px';
    canvas.style.width=`${width}px`;canvas.style.height=`${height}px`;
    const dpr=Math.min(devicePixelRatio||1,3);
    canvas.width=Math.round(width*dpr);canvas.height=Math.round(height*dpr);
    ctx.setTransform(dpr,0,0,dpr,0,0);
    if(reduced.matches) draw(12);
  };
  const project = (x,y,z) => {
    const angle=.22*Math.sin(time*.13)+lean*.16;
    const yy=y*Math.cos(angle)-z*Math.sin(angle), zz=y*Math.sin(angle)+z*Math.cos(angle);
    const depth=3.8/(3.8+zz);
    return {x:width/2+x*width*.58*depth,y:height*.49+yy*height*.49*depth,depth};
  };
  const smooth = n => { const v=Math.max(0,Math.min(1,n));return v*v*(3-2*v); };
  function draw(t) {
    ctx.clearRect(0,0,width,height);
    if(width<40)return;
    const reveal=reduced.matches?1:Math.min(1,t/2);
    ctx.globalAlpha=reveal;
    const count=width<700?1500:points.length;
    const seconds=(Date.now()%60000)/1000;
    const gather=reduced.matches?0:smooth(seconds/2)*(1-smooth((seconds-10)/2));
    const lineFade=reduced.matches?0:smooth((seconds-1.7)/.8)*(1-smooth((seconds-10)/1.2));
    const columns=Math.ceil(Math.sqrt(count*width/height));
    const rows=Math.ceil(count/columns);
    const nodes=new Array(count);
    for(let layer=0;layer<3;layer++) for(let i=0;i<count;i++){
      const p=points[i];
      if(p.layer!==layer)continue;
      const x=wrap(p.x+t*p.vx+Math.sin(t*.22+p.phase)*.035);
      const y=wrap(p.y+t*p.vy*Math.min(6,width/height)+Math.cos(t*.3+p.phase)*.06);
      const z=[1.15,.05,-1.15][layer]+Math.sin(p.phase+t*p.vz)*.22;
      const v=project(x,y,z);
      const edge=Math.min(1,(1-Math.abs(x))*12,(1-Math.abs(y))*12);
      let alpha=p.ink*edge*[.38,.85,1.2][layer]*reveal;
      if(gather>0){
        const col=i%columns, row=Math.floor(i/columns);
        const tx=6+col*(width-12)/(columns-1);
        const ty=6+row*(height-12)/(rows-1);
        v.x+=(tx-v.x)*gather;v.y+=(ty-v.y)*gather;
        alpha+=(.2-alpha)*gather;
      }
      nodes[i]={x:v.x,y:v.y};
      ctx.fillStyle=`rgba(32,32,32,${alpha})`;
      ctx.beginPath();ctx.arc(v.x,v.y,p.size*Math.min(v.depth,1.25)*[.65,1,1][layer],0,Math.PI*2);ctx.fill();
    }
    if(lineFade>0){
      ctx.strokeStyle=`rgba(38,38,38,${.1*lineFade})`;
      ctx.lineWidth=.45;
      ctx.beginPath();
      for(let i=0;i<count;i++){
        const a=nodes[i];
        if(i%columns<columns-1&&i+1<count){
          const b=nodes[i+1];ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);
        }
        if(i+columns<count){
          const b=nodes[i+columns];ctx.moveTo(a.x,a.y);ctx.lineTo(b.x,b.y);
        }
      }
      ctx.stroke();
    }
    ctx.globalAlpha=1;
  }
  const frame = now => {
    raf=0;if(!active||document.hidden||reduced.matches)return;
    if(last)time+=Math.min((now-last)/1000,.05);last=now;
    lean+=(aim-lean)*.025;
    draw(time);raf=requestAnimationFrame(frame);
  };
  const resume=()=>{if(!raf&&active&&!document.hidden&&!reduced.matches){last=0;raf=requestAnimationFrame(frame);}else if(reduced.matches)draw(12);};
  const observer=new IntersectionObserver(entries=>{active=entries[0].isIntersecting;if(!active){cancelAnimationFrame(raf);raf=0;}else resume();});
  observer.observe(header);
  const resize=new ResizeObserver(place);resize.observe(header);
  header.addEventListener('pointermove',e=>{const b=header.getBoundingClientRect();aim=(e.clientY-b.top)/b.height-.5;},{passive:true});
  header.addEventListener('pointerleave',()=>aim=0);
  document.addEventListener('visibilitychange',()=>{if(document.hidden){cancelAnimationFrame(raf);raf=0;}else resume();});
  reduced.addEventListener('change',()=>{cancelAnimationFrame(raf);raf=0;resume();});
  window.addEventListener('pagehide',()=>{cancelAnimationFrame(raf);raf=0;});
  window.addEventListener('pageshow',resume);
  document.fonts.ready.then(()=>{place();resume();});
})();
